module.exports = __webpack_public_path__ + "static/media/paginate-right-arrow.894a2ad9.svg";